<template>
    <el-card class="member-card-index">
        <div class="search flex items-center" v-if="seeContractActive.includes(activeName)">
            <el-tooltip
                effect="dark"
                :content="$t('tooltip.import')"
                placement="bottom">
                <div
                    @click="handleImport()"
                    class="iconfont icon-fitness-shangchuan sell-index-import">
                </div>
            </el-tooltip>
            <el-tooltip
                effect="dark"
                :content="$t('tooltip.export')"
                placement="bottom">
                <div
                    @click="handleExport()"
                    class="iconfont icon-fitness-daochu sell-index-export">
                </div>
            </el-tooltip>
        </div>
        <el-tabs v-loading="loading" v-model="activeName" @tab-click="handleClick">
            <el-form
                v-if="activeName !== 'contract' && activeName !== 'check'"
                class="w-full flex flex-wrap items-center mr-2"
                style="margin-bottom:-12px">
                <el-form-item style="padding-right:5px">
                    <el-select
                        style="width: 150px;"
                        v-model="form.storeId"
                        @change="fetchCard"
                        :placeholder="$t('Common.all_store2')"
                        class="w-full" clearable>
                        <el-option
                        v-for="(item, index) in stores"
                        :key="index"
                        :label="item.name"
                        :value="item.id"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item
                    style="width:150px;padding-right:5px"
                    v-if="activeName==='member' || activeName==='cardsCon'">
                    <el-select
                        v-model="form.contractSalesStaffId"
                        :placeholder="$t('Sell.all_saler')"
                        @change="searchText = null"
                        clearable>
                        <el-input
                            class="search-input-all"
                            type="text"
                            v-model="searchText">
                        </el-input>
                        <el-option
                            v-for="(item, index) in filterStaffs"
                            :key="`${index}-${item.code}`"
                            :label="item.nickname"
                            :value="item.id"
                            :disabled="item.id === 'no'" />
                    </el-select>
                </el-form-item>
                <el-form-item
                    style="width:120px;padding-right:5px"
                    v-if="['member', 'memberCard'].includes(activeName)">
                    <el-select
                        v-model="form.cardTypeCode"
                        :placeholder="$t('Card.all_type')"
                        class="w-full" clearable>
                        <el-option
                            v-for="(item, index) in constant.cardType"
                            :key="`${index}-${item.code}-${item.name}`"
                            :label="item.name"
                            :value="item.code" />
                    </el-select>
                </el-form-item>
                <el-form-item
                    style="width:120px;padding-right:5px"
                    v-if="activeName === 'member'">
                    <el-select
                        v-model="form.cardId"
                        :placeholder="$t('Card.all_zhong')"
                        class="w-full" clearable>
                        <el-option
                            v-for="(item, index) in cards"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item
                    style="width:130px;padding-right:5px"
                    v-if="['personal', 'subscription', 'deposit'].includes(activeName)"
                    >
                    <el-select
                        v-model="form.contractSalesStaffId"
                        :placeholder="$t('Sell.allsaler')"
                        class="w-full" clearable>
                        <el-input
                            class="search-input-all"
                            type="text"
                            v-model="searchText">
                        </el-input>
                        <el-option
                            v-for="(item, index) in filterStaffs"
                            :key="`${index}-${item.code}`"
                            :label="item.nickname"
                            :value="item.id"
                            :disabled="item.id === 'no'" />
                    </el-select>
                </el-form-item>
                <template v-if="activeName === 'personal'">
                    <el-form-item style="width:105px;padding-right:5px">
                        <el-select
                            v-model="form.coachId"
                            @change="searchCoach = null"
                            :placeholder="$t('Common.all_coach')"
                            class="w-full" clearable>
                            <el-input
                                class="search-input-all"
                                type="text"
                                v-model="searchCoach">
                            </el-input>
                            <el-option
                                v-for="(item, index) in filterCoach"
                                :key="index"
                                :label="item.nickname"
                                :value="item.id"
                                :disabled="item.id === 'no'" />
                        </el-select>
                    </el-form-item>
                    <el-form-item style="width:105px;padding-right:5px">
                        <el-select
                            v-model="form.lessonId"
                            :placeholder="$t('Lesson.all_lesson')"
                            class="w-full" clearable>
                            <el-option
                                v-for="(item, index) in lessons"
                                :key="index"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                    </el-form-item>
                </template>
                <el-form-item
                    style="width:120px;padding-right:5px"
                    v-if="seeContractActive.includes(activeName) && activeName !== 'subscription'"
                    >
                    <el-select
                        v-model="form.statusCode"
                        :placeholder="$t('Contract.effective')"
                        class="w-full"
                        clearable>
                        <el-option
                            v-for="(item, index) in constant.contractStatus"
                            :key="index"
                            :label="item.name"
                            :value="item.code"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item
                    style="width:105px;padding-right:5px"
                    v-if="activeName === 'subscription'" >
                    <el-select
                        v-model="form.statusCode"
                        placeholder="$t('Sell.all_status')"
                        class="w-full" clearable>
                        <el-option
                            v-for="(item, index) in constant.prepayStatus"
                            :key="index"
                            :label="item.name"
                            :value="item.code"
                        />
                    </el-select>
                </el-form-item>
                <template v-if="activeName === 'deposit'">
                    <el-form-item style="width:130px;padding-right:5px">
                        <el-select
                            v-model="form.depositType"
                            :placeholder="$t('Sell.all_yajin')"
                            class="w-full" clearable>
                            <el-option
                                v-for="(item, index) in constant.depositType"
                                :key="index"
                                :label="item.name"
                                :value="item.code"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item style="width:130px;padding-right:5px">
                        <el-select
                            v-model="form.depositStatus"
                            :placeholder="$t('Sell.all_ya_type')"
                            class="w-full" clearable>
                            <el-option
                                v-for="(item, index) in constant.depositStatus"
                                :key="index"
                                :label="item.name"
                                :value="item.code"
                            />
                        </el-select>
                    </el-form-item>
                </template>
                <template v-if="activeName === 'memberCard' || activeName === 'storedValueCard'">
                    <el-form-item style="width:130px;padding-right:5px">
                        <el-select
                            v-model="form.saleStatus"
                            :placeholder="$t('Sell.sell_status')"
                            class="w-full" clearable>
                            <el-option :label="$t('Reception.Fifth.normal')" :value="1"/>
                            <el-option :label="$t('Sell.ban')" :value="0"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="mr-2 ml-2">
                        <el-input
                            v-model="form.keyword"
                            style="width: 200px"
                            :placeholder="activeName !== 'memberCard' ? $t('Sell.search_card') : $t('Sell.search_card2')"
                            class="w-full"
                            clearable
                        />
                    </el-form-item>
                </template>
                <el-form-item
                    v-if="!['contract', 'check', 'cardNum'].includes(activeName)"
                    class="el-input--small flex"
                    >
                    <span style="margin-left:5px">{{ dateMsg }}</span>
                    <el-date-picker
                        v-model="date"
                        style="width: 240px;margin-top:5px"
                        type="daterange"
                        range-separator="-"
                        :start-placeholder="$t('Common.choose_date')"
                        :end-placeholder="$t('Common.choose_date')"
                        value-format="yyyy-MM-dd"
                    />
                </el-form-item>
                <el-form-item style="width: 150px;" v-if="activeName === 'cardNum'">
                    <el-select
                        class="w-full"
                        v-model="form.status"
                        :placeholder="$t('Sell.all_status')"
                        clearable>
                        <el-option :label="$t('Reception.Fifth.wei_bind')" :value="1"/>
                        <el-option :label="$t('Sell.bang')" :value="2"/>
                        <el-option :label="$t('Sell.discard')" :value="3"/>
                    </el-select>
                </el-form-item>
                <el-form-item
                    class="mr-2 ml-2"
                    v-if="seeContractActive.includes(activeName)
                    || activeName === 'deposit' || activeName === 'cardNum'"
                    >
                    <el-input
                        v-model="form.keyword"
                        style="width: 280px"
                        :placeholder="$t('Sell.search_client')"
                        class="w-full"
                        clearable
                    />
                </el-form-item>
                <el-form-item class="ml-2">
                    <el-button
                        type="primary"
                        @click="fetchData"
                        style="margin-right:-5px">
                        {{ $t('Common.search') }}
                    </el-button>
                    <el-button @click="handleReset">{{ $t('Common.clear') }}</el-button>
                </el-form-item>
            </el-form>

            <div class="flex justify-between items-top">
                <p style="font-size: 12px;">{{ message }}</p>
                <div
                class="more"
                v-if="!['memberCard', 'storedValueCard', 'contract', 'cardNum'].includes(activeName)">
                    <el-button
                        type="primary"
                        v-if="activeName !== 'deposit'"
                        @click="handlePrint" plain>
                        {{ $t('Sell.he_print') }}
                    </el-button>
                    <el-button type="primary" plain v-if="payBtn" @click="pay">{{ $t('Sell.pay') }}</el-button>
                    <el-button type="primary" @click="ticketPrint" plain>
                        {{ $t('Sell.small_print') }}
                    </el-button>
                    <el-button
                        type="primary" plain
                        v-if="activeName === 'deposit'"
                        @click="openRefund">
                        {{ $t('Sell.refund') }}
                    </el-button>
                    <el-dropdown size="small" style="padding-left:10px">
                        <el-button type="primary" plain>{{ $t('Sell.more') }}</el-button>
                        <el-dropdown-menu slot="dropdown" v-if="activeName==='member'">
                            <template v-if="form.statusCode === 1">
                                <el-dropdown-item @click.native="toUpgrade">{{ $t('Sell.upgrade') }}</el-dropdown-item>
                                <el-dropdown-item @click.native="handleFreeze">{{ $t('Sell.freeze') }}</el-dropdown-item>
                                <el-dropdown-item @click.native="unFreeze">{{ $t('Sell.cancel_freeze') }}</el-dropdown-item>
                                <el-dropdown-item @click.native="openTransfer">{{ $t('Sell.transfer') }}</el-dropdown-item>
                                <el-dropdown-item @click.native="toMember">{{ $t('Sell.bu_card') }}</el-dropdown-item>
                            </template>
                            <el-dropdown-item
                                v-if="form.statusCode === 1 || form.statusCode === 2"
                                @click.native="openRefund">
                                {{ $t('Sell.refund2') }}
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="form.statusCode === 1"
                                @click.native="$refs.memberContract.supportStores(false)">
                                {{ $t('Sell.gift') }}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="modify">{{ $t('Sell.change_number') }}</el-dropdown-item>
                            <el-dropdown-item
                                v-if="form.statusCode === 1"
                                @click.native="secondaryCard"
                            >{{ $t('Sell.change_ci') }}</el-dropdown-item>
                            <el-dropdown-item
                                v-if="form.statusCode === 1 || form.statusCode === 3"
                                @click.native="modifyValidity">
                                {{ $t('Sell.change_validity') }}
                            </el-dropdown-item>
                            <template  v-if="form.statusCode === 1">
                                <el-dropdown-item @click.native="modifyBatchTime">{{ $t('Sell.chang_time') }}</el-dropdown-item>
                                <el-dropdown-item
                                    @click.native="$refs.memberContract.supportStores(true)">
                                    {{ $t('Sell.change_store') }}
                                </el-dropdown-item>
                            </template>
                            <el-dropdown-item
                                v-if="form.statusCode !== 4"
                                @click.native="handleSplit"
                            >{{ $t('Sell.demolition') }}</el-dropdown-item>
                            <el-dropdown-item @click.native="fetchRemark">{{ $t('Sell.remark') }}</el-dropdown-item>
                            <el-dropdown-item @click.native="fetchRecord">{{ $t('Sell.operation_record') }}</el-dropdown-item>
                        </el-dropdown-menu>

                        <el-dropdown-menu slot="dropdown" v-if="activeName==='personal'">
                            <template v-if="form.statusCode === 1">
                                <el-dropdown-item @click.native="handleFreeze">{{ $t('Sell.freeze') }}</el-dropdown-item>
                                <el-dropdown-item @click.native="unFreeze">{{ $t('Sell.cancel_freeze') }}</el-dropdown-item>
                                <el-dropdown-item @click.native="openTransfer">{{ $t('Sell.transfer') }}</el-dropdown-item>
                            </template>
                            <el-dropdown-item
                                v-if="form.statusCode === 1 || form.statusCode === 2"
                                @click.native="openRefund">
                                {{ $t('Sell.refund2') }}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="modify">{{ $t('Sell.change_number') }}</el-dropdown-item>
                            <el-dropdown-item
                                v-if="form.statusCode === 1"
                                @click.native="selectCoach">
                                {{ $t('Sell.change_coach') }}
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="form.statusCode === 1 || form.statusCode === 3"
                                @click.native="modifyValidity">
                                {{ $t('Sell.change_validity') }}
                            </el-dropdown-item>
                            <template v-if="form.statusCode === 1">
                                <el-dropdown-item @click.native="modifyBatchTime">{{ $t('Sell.chang_time') }}</el-dropdown-item>
                                <el-dropdown-item @click.native="secondaryCard">{{ $t('Sell.change_lesson') }}</el-dropdown-item>
                            </template>
                            <el-dropdown-item v-if="form.statusCode !== 4" @click.native="handleSplit">{{ $t('Sell.demolition') }}</el-dropdown-item>
                            <el-dropdown-item @click.native="fetchRemark">{{ $t('Sell.remark') }}</el-dropdown-item>
                            <el-dropdown-item @click.native="fetchRecord">{{ $t('Sell.operation_record') }}</el-dropdown-item>
                        </el-dropdown-menu>

                        <el-dropdown-menu
                            slot="dropdown"
                            v-if="activeName==='locker' || activeName==='cardsCon'"
                            >
                            <el-dropdown-item
                                v-if="form.statusCode === 1"
                                @click.native="openTransfer">
                                {{ $t('Sell.transfer') }}
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="form.statusCode === 1 || form.statusCode === 2"
                                @click.native="openRefund">
                                {{ $t('Sell.refund2') }}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="modify">{{ $t('Sell.change_number') }}</el-dropdown-item>
                            <el-dropdown-item
                                v-if="form.statusCode === 1 || form.statusCode === 3"
                                @click.native="modifyValidity">
                                {{ $t('Sell.change_validity') }}
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="form.statusCode === 1"
                                @click.native="modifyBatchTime">
                                {{ $t('Sell.chang_time') }}
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="form.statusCode !== 4"
                                @click.native="handleSplit">
                                {{ $t('Sell.demolition') }}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="fetchRemark">{{ $t('Sell.remark') }}</el-dropdown-item>
                            <el-dropdown-item @click.native="fetchRecord">{{ $t('Sell.operation_record') }}</el-dropdown-item>
                        </el-dropdown-menu>

                        <el-dropdown-menu slot="dropdown" v-if="activeName==='subscription'">
                            <template v-if="form.statusCode === 1">
                                <el-dropdown-item @click.native="$refs.subscription.joinClub(1)">
                                    {{ $t('Member.add') }}
                                </el-dropdown-item>
                                <el-dropdown-item @click.native="$refs.subscription.joinClub(2)">
                                    {{ $t('Member.xu') }}
                                </el-dropdown-item>
                                <el-dropdown-item @click.native="$refs.subscription.addCard('personal', 4)">
                                    {{ $t('Member.add_personal') }}
                                </el-dropdown-item>
                                <el-dropdown-item @click.native="$refs.subscription.addCard('storeValue', 3)">
                                    {{ $t('Member.add_card') }}
                                </el-dropdown-item>
                                <el-dropdown-item @click.native="$refs.subscription.handleCharge('money')">
                                    {{ $t('Member.up_money') }}
                                </el-dropdown-item>
                            </template>
                            <template v-if="form.statusCode === 1 || form.statusCode === 2">
                                <el-dropdown-item @click.native="openRefund">{{ $t('Sell.refund2') }}</el-dropdown-item>
                                <el-dropdown-item
                                    @click.native="$refs.subscription.handleCharge('day')"
                                >{{ $t('Member.yan') }}</el-dropdown-item>
                            </template>
                            <el-dropdown-item @click.native="fetchRemark">{{ $t('Sell.remark') }}</el-dropdown-item>
                            <el-dropdown-item @click.native="fetchRecord">{{ $t('Sell.operation_record') }}</el-dropdown-item>
                        </el-dropdown-menu>

                        <el-dropdown-menu slot="dropdown" v-if="activeName==='deposit'">
                            <el-dropdown-item @click.native="fetchRecord">{{ $t('Sell.operation_record') }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div
                    class="more flex"
                    v-if="(activeName === 'memberCard' || activeName === 'storedValueCard' || activeName === 'cardNum')"
                    >
                    <el-button type="primary" plain @click="addCard">+{{ $t('tooltip.add') }}</el-button>
                    <el-button type="primary" plain @click="handleEdit">{{ $t('tooltip.edit') }}</el-button>
                    <el-button
                        v-if="activeName === 'storedValueCard'"
                        type="primary" plain
                        @click="$refs.storedValueCard.handleTeamLesson();">
                        {{ $t('Lesson.pay_course_setting') }}
                    </el-button>
                    <el-button
                        v-if="activeName === 'storedValueCard'"
                        @click="$refs.storedValueCard.handleCoachLesson()"
                        type="primary" plain>{{ $t('Lesson.once_buy') }}</el-button>
                    <el-button
                        v-if="activeName === 'memberCard'"
                        type="primary"
                        plain
                        @click="$refs.memberCard.approachTime()">
                        {{ $t('Sell.limi_enter') }}
                    </el-button>
                    <el-button
                        v-if="activeName === 'cardNum'"
                        type="primary"
                        plain
                        @click="$refs.cardSetting.seeRecord()">
                        {{ $t('Sell.operation_record') }}
                    </el-button>
                    <el-button
                        v-if="activeName !== 'cardNum'"
                        type="primary"
                        plain
                        @click="handleDiscard">
                        {{ $t('Sell.ban') }}
                    </el-button>
                    <el-button
                        v-else
                        type="primary"
                        plain
                        @click="$refs.cardSetting.handleDelete()"
                    >{{ $t('Sell.discard') }}</el-button>
                    <el-button
                        type="primary"
                        plain
                        @click="handleRestore"
                    >{{ $t('tooltip.refresh') }}</el-button>
                </div>
            </div>

            <el-tab-pane
                v-if="$$filterPermission('售卖-会籍合同管理-查看自己销售的')
                || $$filterPermission('售卖-会籍合同管理-查看全部')"
                :label="$t('Sell.title1')"
                name="member">
                <member-contract
                    ref="memberContract"
                    :activeName="activeName"
                    :form.sync="form"
                    v-model="message"
                    :date="date"
                    v-on:headListen="headListen"
                    :stores="stores"/>
            </el-tab-pane>
            <el-tab-pane
                v-if="$$filterPermission('售卖-私教合同管理-查看自己销售的')
                || $$filterPermission('售卖-私教合同管理-查看全部')"
                :label="$t('Sell.title2')"
                name="personal">
                <trainer-contract
                    ref="personal"
                    :activeName="activeName"
                    :form="form"
                    :contractNum="contractNum"
                    :date="date"
                    :stores="stores"
                    v-on:headListen="headListen"
                    v-model="message" />
            </el-tab-pane>
            <el-tab-pane
                v-if="$$filterPermission('售卖-租赁柜合同管理-查看自己销售的')
                || $$filterPermission('售卖-租赁柜合同管理-查看全部')"
                :label="$t('Sell.title3')"
                name="locker">
                <cabinets-contract
                    ref="locker"
                    :activeName="activeName"
                    :form="form"
                    :date="date"
                    :stores="stores"
                    v-on:headListen="headListen"
                    v-model="message" />
            </el-tab-pane>
            <el-tab-pane
                v-if="$$filterPermission('售卖-储值卡合同管理-查看自己销售的')
                || $$filterPermission('售卖-储值卡合同管理-查看全部')"
                :label="$t('Sell.title4')"
                name="cardsCon">
                <cards-contract
                    ref="cardsCon"
                    :activeName="activeName"
                    :form="form"
                    :contractNum="contractNum"
                    v-model="message"
                    :date="date"
                    :stores="stores"
                    v-on:headListen="headListen"/>
            </el-tab-pane>
            <el-tab-pane
                v-if="$$filterPermission('售卖-定金合同管理-仅查看自己销售的')
                || $$filterPermission('售卖-定金合同管理-查看全部')"
                :label="$t('Sell.title5')"
                name="subscription">
                <deposit-contract
                    :activeName="activeName"
                    ref="subscription"
                    v-on:headListen="headListen"
                    :date="date"
                    v-model="message"
                    :form="form" />
            </el-tab-pane>
            <el-tab-pane
                v-if="$$filterPermission('售卖-押金管理-仅能查看自己销售的')
                || $$filterPermission('售卖-押金管理-查看全部')"
                :label="$t('Sell.title6')"
                name="deposit">
                <deposit-control
                    :activeName="activeName"
                    ref="deposit"
                    v-model="message"
                    v-on:headListen="headListen"
                    :date="date"
                    :form="form" />
            </el-tab-pane>
            <el-tab-pane
                v-if="$$filterPermission('售卖-会籍卡/储值卡管理-查看会籍卡/储值卡')"
                :label="$t('Sell.title7')"
                name="memberCard">
                <member-card
                    ref="memberCard"
                    :activeName="activeName"
                    :form="form"
                    v-model="message"
                    :date="date"
                    :stores="stores"/>
            </el-tab-pane>
            <el-tab-pane
                v-if="$$filterPermission('售卖-会籍卡/储值卡管理-查看会籍卡/储值卡')"
                :label="$t('Sell.title8')"
                name="storedValueCard">
                <stored-value-card
                    ref= "storedValueCard"
                    :activeName="activeName"
                    :form="form"
                    v-model="message"
                    :stores="stores"
                    :date="date" />
            </el-tab-pane>
            <el-tab-pane
                v-if="$$filterPermission('售卖-合同设置-合同设置及修改')"
                :label="$t('Sell.title9')"
                name="contract">
                <contract-setting
                    ref="contractSetting"
                    :activeName="activeName"
                    :stores="stores"
                    v-model="message"
                    v-on:headListen="headListen" />
            </el-tab-pane>
            <!--  <el-tab-pane label="合同底价及审批" name="check"></el-tab-pane> -->
            <el-tab-pane
                v-if="$$filterPermission('售卖-卡号管理-查看卡号设置管理')"
                :label="$t('Sell.title10')"
                name="cardNum">
                <card-setting
                    ref="cardSetting"
                    :activeName="activeName"
                    :form.sync="form"
                    :stores="stores"
                    v-model="message" />
            </el-tab-pane>
        </el-tabs>

        <!-- 修改合同编号弹窗 -->
        <el-dialog
            :title="$t('Sell.change_number')"
            class="sell-index-dialog"
            :visible.sync="visible">
            <el-form
                ref="contractNumForm"
                :model="contractNumForm"
                :rules="rules"
                :status-icon="true"
                label-width="90px"
                label-suffix=" : "
                label-position="right"
                v-loading="form_loading"
            >
                <el-form-item :label="$t('Sell.old_number')" prop="contractNum">
                    <el-input v-model.trim="contractNumForm.contractNum"/>
                </el-form-item>
                <el-form-item :label="$t('Sell.new_number')" prop="newContractNum">
                    <el-input style="width: 280px;" class="mr-3" v-model.trim="contractNumForm.newContractNum"/>
                    <el-button
                        type="success"
                        v-if="autoContractNum"
                        @click="getAutoContractNum"
                    >{{ $t('Common.zidong') }}</el-button>
                </el-form-item>
            </el-form>
            <el-button
                type="primary"
                slot="footer"
                @click="submitContractNum"
            >{{ $t('Message.confirm') }}</el-button>
        </el-dialog>
        <!-- 对内备注弹窗 -->
        <el-dialog
            :title="$t('Sell.edit_remark')"
            class="sell-index-dialog"
            :visible.sync="remark_visible">
            <el-form
                ref="remarkInsert"
                :model="remarkForm"
                :rules="remarkRules"
                :status-icon="true"
                label-suffix=" : "
                label-position="right"
                v-loading="form_loading"
            >
                <el-form-item :label="$t('Common.remark')" prop="remark" style="margin-top:-20px">
                    <el-input type="textarea"
                        v-model="remarkForm.remark"
                        :placeholder="$t('Fill.remark_placeholder')"
                        rows="10"
                    />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer"  style="text-align:center">
                <el-button
                    type="primary"
                    slot="footer"
                    @click="submitRemark"
                >{{ $t('Message.confirm') }}</el-button>
            </div>
        </el-dialog>

        <!-- 转让 -->
        <transfer-dialog
            ref="transfer"
            @fetchData="fetchData"
            :activeName="activeName">
        </transfer-dialog>
        <!-- 升级合同弹窗 -->
        <upgrade-dialog
            @refreshData="fetchData"
            ref="upgrade"
            :stores="stores"
            :activeName="activeName" />
        <!-- 补卡弹窗 -->
        <replace-card ref="replaceCard" @fetchData="fetchData" />
        <!-- 退款 -->
        <refund-dialog
            ref="refund"
            @fetchData="fetchData"
            :activeName='activeName'>
        </refund-dialog>
        <!-- 获取合同变更历史弹窗 -->
        <change-record-form ref="changeRecord" :activeName="activeName"/>
        <!-- 冻结合同 -->
        <handle-freeze
            @fetchData="fetchData"
            ref="freeze"
            :activeName="activeName" />
        <!-- 修改剩余次数 -->
        <secondary-card
            :activeName="activeName"
            @fetchData="fetchData"
            ref="secondary" />
        <!-- 修改合同有效期 -->
        <modify-validity
            :activeName="activeName"
            @fetchData="fetchData"
            ref="validity" />
        <!-- 业绩拆分 -->
        <handle-split @fetchData="fetchData" ref="split" :activeName="activeName" />
    </el-card>
</template>

<script>
import {
    Tooltip,
    Popover,
    DatePicker,
    Table,
    TableColumn,
    Pagination,
    Tag,
    Tabs,
    TabPane,
    OptionGroup,
    Dialog,
    CheckboxGroup,
    Checkbox,
    RadioGroup,
    Radio,
    Dropdown,
    DropdownMenu,
    DropdownItem,
} from 'element-ui';
import MemberContract from '@/components/TableCom/Sell/MemberContract';
import ContractSetting from '@/components/TableCom/Sell/ContractSetting';
import CardSetting from '@/components/TableCom/Sell/CardSetting';
import MemberCard from '@/components/TableCom/Sell/MemberCard';
import TrainerContract from '@/components/TableCom/Sell/TrainerContract';
import CabinetsContract from '@/components/TableCom/Sell/CabinetsContract';
import CardsContract from '@/components/TableCom/Sell/CardsContract';
import DepositContract from '@/components/TableCom/Sell/DepositContract';
import DepositControl from '@/components/TableCom/Sell/DepositControl';
import StoredValueCard from '@/components/TableCom/Sell/StoredValueCard';
import TransferDialog from '@/components/Dialog/Sell/TransferDialog.vue';
import UpgradeDialog from '@/components/Dialog/Sell/UpgradeDialog.vue';
import RefundDialog from '@/components/Dialog/Sell/RefundDialog.vue';
import ChangeRecordForm from '@/components/Dialog/Sell/ChangeRecordForm.vue';
import ReplaceCard from '@/components/Dialog/Sell/ReplaceCard.vue';
import handleFreeze from '@/components/Dialog/Sell/handleFreeze.vue';
import secondaryCard from '@/components/Dialog/Sell/secondaryCard.vue';
import modifyValidity from '@/components/Dialog/Sell/modifyValidity.vue';
import HandleSplit from '@/components/Dialog/Sell/HandleSplit.vue';
import filterRole from '@/mixins/filterRole.js';

export default {
    name: 'sell',
    components: {
        Tooltip: Tooltip,
        Popover: Popover,
        ElDatePicker: DatePicker,
        ElTable: Table,
        ElTableColumn: TableColumn,
        ElPagination: Pagination,
        ElTag: Tag,
        ElTabs: Tabs,
        ElTabPane: TabPane,
        ElOptionGroup: OptionGroup,
        ElDialog: Dialog,
        ElCheckboxGroup: CheckboxGroup,
        ElCheckbox: Checkbox,
        ElRadioGroup: RadioGroup,
        ElRadio: Radio,
        ElDropdown: Dropdown,
        ElDropdownMenu: DropdownMenu,
        ElDropdownItem: DropdownItem,
        MemberContract,
        ContractSetting,
        CardSetting,
        MemberCard,
        TrainerContract,
        CabinetsContract,
        CardsContract,
        DepositContract,
        DepositControl,
        StoredValueCard,
        TransferDialog,
        UpgradeDialog,
        RefundDialog,
        ChangeRecordForm,
        ReplaceCard,
        handleFreeze,
        secondaryCard,
        modifyValidity,
        HandleSplit,
    },
    mixins: [filterRole],
    data() {
        return {
            contractNumForm: {
                contractNum: '',
                newContractNum: '',
            },
            remarkUrl: '',
            form_loading: false,
            dateMsg: this.$t('Sell.sign_date'),
            message: '',
            contracts: [],
            cards: [],
            stores: [],
            staffs: [],
            coaches: [],
            lessons: [],
            date: [],
            constant: {},
            remarkForm: {
                remark: '',
            },
            visible: false,
            remark_visible: false,
            form: {
                statusCode: Number(this.$route.query.status) || 1,
            },
            rules: {
                newContractNum: [
                    { required: true, message: this.$t('Fill.new_number_placeholder'), trigger: 'blur' },
                ],
            },
            remarkRules: {
                remark: [
                    { required: true, message: this.$t('Fill.inside_remark_placeholder'), trigger: 'blur' },
                ],
            },
            loading: false,
            seeContractActive: [
                'member',
                'personal',
                'locker',
                'cardsCon',
                'subscription',
            ],
            editableTabs: [
                {
                    name: 'member',
                    isShow: this.$$filterPermission('售卖-会籍合同管理-查看自己销售的')
                    || this.$$filterPermission('售卖-会籍合同管理-查看全部'),
                }, {
                    name: 'personal',
                    isShow: this.$$filterPermission('售卖-私教合同管理-查看自己销售的')
                    || this.$$filterPermission('售卖-私教合同管理-查看全部'),
                }, {
                    name: 'locker',
                    isShow: this.$$filterPermission('售卖-租赁柜合同管理-查看自己销售的')
                    || this.$$filterPermission('售卖-租赁柜合同管理-查看全部'),
                }, {
                    name: 'cardsCon',
                    isShow: this.$$filterPermission('售卖-储值卡合同管理-查看自己销售的')
                    || this.$$filterPermission('售卖-储值卡合同管理-查看全部'),
                }, {
                    name: 'subscription',
                    isShow: this.$$filterPermission('售卖-定金合同管理-仅查看自己销售的')
                    || this.$$filterPermission('售卖-定金合同管理-查看全部'),
                }, {
                    name: 'deposit',
                    isShow: this.$$filterPermission('售卖-押金管理-仅能查看自己销售的')
                    || this.$$filterPermission('售卖-押金管理-查看全部'),
                }, {
                    name: 'memberCard',
                    isShow: this.$$filterPermission('售卖-会籍卡/储值卡管理-查看会籍卡/储值卡'),
                }, {
                    name: 'storedValueCard',
                    isShow: this.$$filterPermission('售卖-会籍卡/储值卡管理-查看会籍卡/储值卡'),
                }, {
                    name: 'contract',
                    isShow: this.$$filterPermission('售卖-合同设置-合同设置及修改'),
                }, {
                    name: 'cardNum',
                    isShow: this.$$filterPermission('售卖-卡号管理-查看卡号设置管理'),
                },
            ],
            payBtn: false,
            // 自动生成合同编号
            autoContractNum: false,
            autoStoreId: null,
            contractUrl: null,
            autoStoreId: null,
            // 搜索框
            searchText: null,
            searchCoach: null,
            // 销售
            ids: [5, 6],
        };
    },
    computed: {
        filterStaffs() {
            if (!this.searchText) return this.staffs;
            const arr = this.staffs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
        filterCoach() {
            if (!this.searchCoach) return this.coaches;
            const arr = this.coaches.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchCoach.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
        activeName: {
            get: function () {
                if (this.$route.query.activeName) return this.$route.query.activeName;
                return this.editableTabs.find(el => el.isShow).name;
            },
            set: function (newValue) {
                if (!this.contractNum) return this.$router.replace({query: {activeName: newValue}});
                this.$router.replace({
                    query: {
                        activeName: newValue,
                        contractNum: this.contractNum,
                    }
                });
            }
        },
        contractNum: {
            get: function () {
                if (this.$route.query.contractNum) return this.$route.query.contractNum;
                return null;
            },
            set: function (val) {
                // this.form.contractNum = val;
            },
        },
    },
    watch: {
        // 搜索信息
        message(val) {
            this.headListen([]);
            this.message = val;
        },
        activeName(val) {
            if (this.seeContractActive.includes(val) && val !== 'subscription') {
                this.dateMsg = this.$t('Sell.sign_date');
            }
            if (val === 'subscription' || val === 'deposit') {
                this.dateMsg = this.$t('Sell.charge_date');
            }
            if (val === 'memberCard' || val === 'storedValueCard') {
                this.dateMsg = this.$t('Sell.sell_date');
            }
        },
        visible(val) {
            if (!val) {
                // 清空时间
                // this.$refs.contractNumForm.clearValidate();
                this.form = {
                    name: '',
                    capacity: '',
                    statusCode: 1,
                };
            }
        },
    },
    methods: {
        // 删除/恢复后刷新页面
        flushData() {
            switch (this.activeName) {
            case 'member':
                this.$refs.memberContract.flush(1);
                break;
            case 'personal':
                this.$refs.personal.flush(1);
                break;
            case 'locker':
                this.$refs.locker.flush(1);
                break;
            case 'cardsCon':
                this.$refs.cardsCon.flush(1);
                break;
            case 'subscription':
                this.$refs.subscription.fetchData(1);
                break;
            case 'deposit':
                this.$refs.deposit.fetchData(1);
                break;
            case 'memberCard':
                this.$refs.memberCard.flush(1);
                break;
            case 'storedValueCard':
                this.$refs.storedValueCard.flush(1);
                break;
            case 'contract':
                break;
            case 'cardNum':
                this.$refs.cardSetting.flush(1);
                break;
            default:
                break;
            }
        },
        fetchData() {
            if (this.form.statusCode === 2) this.payBtn = true;
            else this.payBtn = false;
            switch (this.activeName) {
            case 'member':
                this.$refs.memberContract.fetchData();
                break;
            case 'personal':
                this.$refs.personal.fetchData();
                break;
            case 'locker':
                this.$refs.locker.fetchData();
                break;
            case 'cardsCon':
                this.$refs.cardsCon.fetchData();
                break;
            case 'subscription':
                this.$refs.subscription.fetchData();
                break;
            case 'deposit':
                this.$refs.deposit.fetchData();
                break;
            case 'memberCard':
                this.$refs.memberCard.fetchData();
                break;
            case 'storedValueCard':
                this.$refs.storedValueCard.fetchData();
                break;
            case 'contract':
                break;
            case 'check':
                break;
            case 'cardNum':
                this.$refs.cardSetting.fetchData();
                break;
            default:
                break;
            }
        },
        // 获取下拉列表常量
        fetchConstant() {
            this.loading = true;
            API.get('constant/contract')
            .then(res => {
                this.constant = res;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchLesson() {
            if (this.activeName !== 'personal') return;
            this.loading = true;
            API.get('lesson/coach/list')
            .then(res => {
                this.lessons = res;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchCard() {
            this.loading = true;
            API.get('member-card/list', {
                params: {
                    storeId: this.form.storeId,
                },
            })
            .then(res => {
                this.cards = res;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchStore() {
            this.loading = true;
            API.get('store/list')
            .then(res => {
                this.stores = res;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        // 获取销售筛选列表
        async fetchStaff() {
            this.loading = true;
            // const ids = [5, 6];
            this.staffs = await this.filterRole(null, this.ids);
            this.loading = false;
        },
        // 获取教练筛选列表
        async fetchCoach() {
            this.loading = true;
            const ids = [7, 8];
            this.coaches = await this.filterRole(null, ids);
            this.loading = false;
        },
        // 获取对内备注详情
        fetchRemark() {
            if (this.validSingle()) {
                this.loading = true;
                this.chooseUrl();
                API.get(`${this.remarkUrl}`).then(res => {
                    this.remarkForm.remark = res;
                    this.remark_visible = true;
                }).finally(() => {
                    this.loading = false;
                }).catch(err => {
                    $ele.$message.error(err);
                });
            }
        },
        handleReset() {
            this.$router.replace({query: {
                activeName: this.activeName,
            }});
            this.date = [];
            this.form = {};
            this.flushData();
        },
        // 监听自组建选择id变化
        headListen(data) {
            this.contracts = data;
            if (data.length > 0) this.contractNumForm.contractNum = data[0].contractNum;
        },
        // 更改对内备注
        submitRemark() {
            this.form_loading = true;
            this.chooseUrl();
            if (this.$$filterPermission('售卖-合同管理-编辑内部备注')) {
                API.post(`${this.remarkUrl}`, this.remarkForm)
                .then(() => {
                    $ele.$message.success(this.$t('Message.save'));
                })
                .finally(() => {
                    this.form_loading = false;
                    this.remark_visible = false;
                    this.flushData();
                });
            } else {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
            }
        },
        // 更改合同编号
        submitContractNum() {
            this.loading = true;
            API.put(
                `contract/common/${this.contracts[0].contractNum}/contract-num`,
                {},
                {
                    params: {
                        newContractNum: this.contractNumForm.newContractNum,
                    },
                }
            ).then(() => {
                $ele.$message.success(this.$t('Message.save'));
            }).finally(() => {
                this.form_loading = false;
                this.loading = false;
                this.visible = false;
                this.contractNumForm.newContractNum = null;
                this.flushData();
            });
        },
        // 恢复
        handleRestore() {
            if (this.activeName === 'memberCard') this.$refs.memberCard.handleRestore();
            if (this.activeName === 'cardNum') this.$refs.cardSetting.handleRestore();
            if (this.activeName === 'storedValueCard') this.$refs.storedValueCard.handleRestore();
        },
        // 禁用
        handleDiscard() {
            if (this.activeName === 'memberCard') this.$refs.memberCard.handleForbidden();
            if (this.activeName === 'storedValueCard') this.$refs.storedValueCard.handleForbidden();
        },
        // 修改合同编号
        modify() {
            if (this.validSingle()) {
                if (this.$$filterPermission('售卖-合同管理-修改合同编号'))
                this.featchDetail();
                else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        // 获取合同详情
        featchDetail() {
            this.chooseUrl();
            API.get(this.contractUrl).then(res => {
                this.contractNumForm.contractNum = res.contractNum;
                this.autoStoreId = res.storeId;
                this.visible = true;
                this.stores.forEach(el => {
                    if (el.id === res.storeId) {
                        this.autoContractNum = el.autoContractNum;
                    }
                });
            });
        },
        // 自动生成编号
        getAutoContractNum() {
            API.get(`store/${this.autoStoreId}/gen-contract-num`).then(res => {
                this.contractNumForm.newContractNum = res;
            }).finally(() => {});
        },
        // 获取不同合同对内备注的url
        chooseUrl() {
            switch (this.activeName) {
            case 'member':
                this.remarkUrl = `contract/mshp/${this.contracts[0].contractNum}/internal-remark`;
                this.contractUrl = `contract/mshp/${this.contracts[0].contractNum}`;
                break;
            case 'personal':
                this.remarkUrl = `contract/coach/${this.contracts[0].contractNum}/internal-remark`;
                this.contractUrl = `contract/coach/${this.contracts[0].contractNum}`;
                break;
            case 'locker':
                this.remarkUrl = `contract/locker/${this.contracts[0].contractNum}/internal-remark`;
                this.contractUrl = `contract/locker/${this.contracts[0].contractNum}`;
                break;
            case 'cardsCon':
                this.remarkUrl = `contract/cz-card/${this.contracts[0].contractNum}/internal-remark`;
                this.contractUrl = `contract/cz-card/${this.contracts[0].contractNum}`;
                break;
            case 'subscription':
                this.remarkUrl = `contract/prepay/${this.contracts[0].contractNum}/internal-remark`;
                break;
            case 'deposit':
                break;
            default:
                break;
            }
        },
        // 添加会籍卡 & 添加处置卡 & 添加卡号设置
        addCard() {
            if (this.activeName === 'memberCard') this.$refs.memberCard.handleEdit();
            if (this.activeName === 'cardNum') this.$refs.cardSetting.handleEdit();
            if (this.activeName === 'storedValueCard') this.$refs.storedValueCard.handleAdd();
        },
        // 升级合同
        toUpgrade() {
            if (this.validSingle()) {
                if (this.$$filterPermission('售卖-合同管理-合同升级'))
                this.$refs.upgrade.open(this.contracts[0]);
                else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        // 冻结
        handleFreeze() {
            if (this.validSingle()) {
                if (this.$$filterPermission('售卖-合同管理-合同冻结、取消冻结、转让、补卡'))
                this.$refs.freeze.open(this.contracts[0]);
                else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        // 取消冻结
        unFreeze() {
            if (this.validSingle()) {
                $ele.$confirm(this.$t('Message.cancel_freeze'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    cancelButtonText: this.$t('Common.cancel'),
                    type: 'warning',
                }).then(() => {
                    if (this.$$filterPermission('售卖-合同管理-合同冻结、取消冻结、转让、补卡')) {
                        let url;
                        if (this.activeName === 'member') url = `contract/mshp/${this.contracts[0].contractNum}/unfreeze`;
                        else url = `contract/coach/${this.contracts[0].contractNum}/unfreeze`;
                        API.post(url).then(() => {
                            $ele.$message.success(this.$t('Message.success'));
                            this.fetchData();
                        });
                    } else {
                        $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                            confirmButtonText: this.$t('Message.confirm'),
                            callback: action => {},
                        });
                    }
                }).catch(() => {
                    // $ele.$message.info('已取消删除');
                });
            }
        },
        toMember() {
            if (this.validSingle()) {
                if (this.$$filterPermission('售卖-合同管理-合同冻结、取消冻结、转让、补卡'))
                this.$refs.replaceCard.open(this.contracts[0]);
                else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        // 转让
        openTransfer() {
            if (this.validSingle()) {
                if (this.$$filterPermission('售卖-合同管理-合同冻结、取消冻结、转让、补卡')) {
                    this.$refs.transfer.open(this.contracts[0]);
                } else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        // 退款
        openRefund() {
            if (this.validSingle()) {
                if ((this.activeName === 'deposit' && this.$$filterPermission('售卖-押金管理-押金退款'))
                || (this.activeName !== 'deposit' && this.$$filterPermission('售卖-合同管理-合同退款重办'))) {
                    this.$refs.refund.open(this.contracts[0]);
                } else if ((this.activeName === 'deposit' && !this.$$filterPermission('售卖-押金管理-押金退款'))
                || (this.activeName !== 'deposit' && !this.$$filterPermission('售卖-合同管理-合同退款重办'))) {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        // 编辑会籍卡 & 编辑储值卡 &编辑卡号设置
        handleEdit() {
            if (this.activeName === 'cardNum') this.$refs.cardSetting.handleEdit('update');
            if (this.activeName === 'storedValueCard') this.$refs.storedValueCard.handleEdit();
            if (this.activeName === 'memberCard') this.$refs.memberCard.handleEdit('update');
        },
        handleClick(tab) {
            this.form = {
                statusCode: 1,
            };
            this.date = [];
            this.payBtn = false;
            if (['personal', 'cardsCon'].includes(tab.name)) {
                this.contractNum = null;
                this.$router.replace({
                    name: 'Sell',
                    query: {
                        activeName: tab.name,
                        contractNum: null,
                    },
                });
            }
            // 合同不同销售不同
            console.log(tab);
            console.log(tab.name);
            if (['member', 'deposit'].includes(tab.name)) this.ids = [5, 6];
            else if (['cardsCon', 'subscription'].includes(tab.name)) this.ids = null;
            else if (tab.name === 'personal') this.ids = [7, 8, 10];
            if (['member', 'deposit', 'cardsCon', 'subscription', 'personal'].includes(tab.name)) this.fetchStaff();
        },
        // 修改剩余次数
        secondaryCard() {
            if (this.validSingle()) {
                if (this.$$filterPermission('售卖-私教合同管理-修改剩余课时'))
                this.$refs.secondary.open(this.contracts[0]);
                else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        // 获取合同变更记录
        fetchRecord() {
            if (this.validSingle()) {
                if ((this.activeName === 'deposit' && this.$$filterPermission('售卖-押金管理-查看操作记录'))
                || (this.activeName !== 'deposit' && this.$$filterPermission('售卖-合同管理-查看操作记录'))) {
                    this.$refs.changeRecord.open(this.contracts[0].contractNum);
                } else if ((this.activeName === 'deposit' && !this.$$filterPermission('售卖-押金管理-查看操作记录'))
                || (this.activeName !== 'deposit' && !this.$$filterPermission('售卖-合同管理-查看操作记录'))) {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        // 校验选择条数
        validSingle() {
            let msg;
            const type = this.activeName;
            if (type === 'subscription' || type === 'member' || type === 'personal') msg = this.$t('Message.choose_contract');
            else msg = this.$t('Message.choose_once');

            if (this.contracts.length < 1) $ele.$message.warning(msg);
            else if (this.contracts.length > 1) $ele.$message.warning(this.$t('Message.once_data'));
            else return true;
        },
        // 收银
        pay() {
            if (this.activeName === 'member') this.$refs.memberContract.pay();
            if (this.activeName === 'cardsCon') this.$refs.cardsCon.pay();
            if (this.activeName === 'personal') this.$refs.personal.pay();
            if (this.activeName === 'locker') this.$refs.locker.pay();
        },
        // 合同打印
        handlePrint() {
            if (!this.contracts.length) return;
            if (this.contracts.length > 1) return $ele.$message.warning(this.$t('Message.once_data'));
            if (!this.$$filterPermission('售卖-合同管理-合同打印')) return this.$router.push('/403');
            const location = window.location;
            const contractNum = this.contracts[0].contractNum;
            const link = `${location.origin}/admin/preview?contractNum=${contractNum}&activeName=${this.activeName}`;
            window.open(link);
        },
        // 小票打印
        ticketPrint() {
            if (!this.contracts.length) return;
            if (this.contracts.length > 1) return $ele.$message.warning(this.$t('Message.once_data'));
            if (!this.$$filterPermission('售卖-合同管理-小票打印')) return this.$router.push('/403');
            const location = window.location;
            const contractNum = this.contracts[0].contractNum;
            const link = `${location.origin}/admin/ticket?contractNum=${contractNum}&activeName=${this.activeName}`;
            window.open(link);
        },
        // 修改合同有效期
        modifyValidity() {
            if (this.validSingle()) {
                if (this.$$filterPermission('售卖-合同管理-修改合同有效期'))
                this.$refs.validity.open(this.contracts[0]);
                else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        // 批量修改合同开始时间
        modifyBatchTime() {
            if (!this.$$filterPermission('售卖-合同管理-批量修改合同开始时间')) {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
                return;
            }
            if (this.activeName === 'member') this.$refs.memberContract.openBatch();
            else if (this.activeName === 'personal') this.$refs.personal.openBatch();
            else if (this.activeName === 'locker') this.$refs.locker.openBatch();
            else if (this.activeName === 'cardsCon') this.$refs.cardsCon.openBatch();
        },
        // 业绩拆分
        handleSplit() {
            if (this.contracts.length < 1) $ele.$message.warning(this.$t('Message.choose_one'));
            else if (this.contracts.length > 1) $ele.$message.warning(this.$t('Message.one_data'));
            else if (!this.$$filterPermission('售卖-合同管理-业绩拆分')) {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
            }
            else this.$refs.split.open(this.contracts[0]);
        },
        selectCoach() {
            this.$refs.personal.openCoach();
        },
        // 导入
        handleImport() {
            if (this.$$filterPermission('售卖-合同管理-导入合同')) {
                let type;
                if (this.activeName === 'member') type = 3;
                else if (this.activeName === 'personal') type = 4;
                else if (this.activeName === 'locker') type = 5;
                else if (this.activeName === 'cardsCon') type = 6;
                else if (this.activeName === 'subscription') type = 7;
                this.$router.push({
                    name: 'Upload',
                    query: {
                        isMember: 'sell',
                        type: type,
                    },
                });
            } else this.$router.push('/403');
        },
        // 导出
        handleExport() {
            let url;
            if (this.activeName === 'member') url = 'export/contract/mshp';
            else if (this.activeName === 'personal') url = 'export/contract/coach';
            else if (this.activeName === 'locker') url = 'export/contract/locker';
            else if (this.activeName === 'cardsCon') url = 'export/contract/cz-card';
            else if (this.activeName === 'subscription') url = 'export/contract/prepay';
            $ele.$confirm(this.$t('Message.export_confirm'), this.$t('Message.tip_title'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                if (this.$$filterPermission('售卖-合同管理-导出合同')) {
                    API.post(url, this.form)
                    .then(res => {
                        this.$router.push({
                            name: 'Setting.List',
                            query: {
                                activeName: 'sixth',
                            },
                        });
                    });
                } else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }).catch(() => {
                // $ele.$message('取消操作');
            });
        },
    },
    created() {
        if (this.$route.query.keyword) this.form.keyword = this.$route.query.keyword;
        if (this.$route.params.contractNum) this.form.contractNum = this.$route.params.contractNum;
        if (this.$route.query.status) this.payBtn = this.$route.query.status === 2;
        this.fetchConstant();
        this.fetchCard();
        this.fetchStaff();
        this.fetchLesson();
        this.fetchStore();
        this.fetchCoach();
    },
};
</script>

<style lang="scss">
.member_search {
    width: 40%;
}
.member-card-index {
    .search {
        position: relative;
        float: right;
        right: 0;
        top: 16px;
        z-index: 2;
        padding: 0;
        margin: 0;
    }
}
.member-card-index {
    min-width: 1110px;
}
.more {
    padding-bottom: 20px;
}
.sell-index-import {
    font-size: 25px;
}
.sell-index-export {
    font-size: 18px;
}
.sell-index-dialog {
    .el-dialog {
        width: 500px;
    }
}
</style>
